const HRApprovalStatus = {
    WAITING_SUBMIT_FOR_APPROVAL: 1,
    WAITING_APPROVAL: 2,
    APPROVED: 3,
    DECLINED: 4
};

export default HRApprovalStatus;